// Types
import AppError from './AppError';

export const isAppError = (err: unknown): err is AppError => err instanceof AppError;
